<template>
    <div class="settings-filters-popup-component-container">
        <div class="settings-filters-popup-component-wrapper">
            <div class="settings-filters-popup-header-container">
                <div class="settings-filters-popup-header-img-container">
                    <img :src="require(`../../assets/icons/${filterOptions.name}.png`)" alt="Filter type image">
                </div>
            </div>

            <div class="filter-options-container">
                <ul class="filter-options-list">
                    <li class="filter-option-item" v-for="(filterOption, key) in filterOptions.options" :key="key" @click="toggleFilterOptionStatus(key)">
                        <div class="filter-option-checkbox-container">
                            <div class="filter-option-checkbox-wrapper">
                                <div v-if="filterOption" class="filter-option-checkbox-img-container">
                                    <img src="../../assets/icons/check.png" alt="Check icon">
                                </div>
                            </div>
                        </div>

                        <div class="filter-option-title-container">
                            <p>{{ $t(key) }}</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="action-btns-container">
                <div class="btn-container cancel-btn-container" @click="closeSettingsFiltersPopupHandle">
                    <div class="btn cancel-btn">
                        <img src="../../assets/icons/cancel_icon.png" alt="Cancel icon">
                    </div>
                </div>

                <div class="btn-container ok-btn-container" @click="applyFilter(filterOptions)">
                    <div class="btn ok-btn">
                        <img src="../../assets/icons/check.png" alt="Check icon">
                    </div>
                </div>
            </div>

        </div>
        
    </div>
</template>

<script>
export default {
    name: 'SettingsFiltersPopup',
    props: {
        clickedFilterIndex: Number,
        clickedFilterOptions: Object,
        closeSettingsFiltersPopup: Function,
        applyFilter: Function,
        // resetSelectedTimeSlot: Function,
    },
    data() {
        return {
            filterOptions: JSON.parse(JSON.stringify(this.clickedFilterOptions)),
        };
    },
    methods: {
        closeSettingsFiltersPopupHandle: function () {
            // console.log(this.clickedFilterOptions);
            // console.log(this.filterOptions);
            this.filterOptions = {...this.clickedFilterOptions},
            this.closeSettingsFiltersPopup();
        },
        toggleFilterOptionStatus: function(optionKey) {
            this.filterOptions.options[optionKey] = !this.filterOptions.options[optionKey];
        }
    }
}
</script>

<style>
.settings-filters-popup-component-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
    z-index: 99;
}

.settings-filters-popup-component-container .settings-filters-popup-component-wrapper {
    width: 85%;
    max-width: 275px;
    min-width: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 22px;
    background: #ffffff;
    border: 2px solid #92d400;
    overflow: hidden;
}

.settings-filters-popup-component-container .settings-filters-popup-header-container {
    width: 100%;
    padding: 2px 15px;
    border-top: 1px solid #d6d9d9;
    border: 1px solid #92d400;
    border-bottom: 1px solid #d6d9d9;
    background: #92d400;
}

.settings-filters-popup-component-container .settings-filters-popup-header-img-container {
    width: 60px;
}

.settings-filters-popup-component-container .settings-filters-popup-header-img-container img {
    width: 100%;
    filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(66%) hue-rotate(203deg) brightness(115%) contrast(100%);
}

.settings-filters-popup-component-container .filter-options-container {
    width: 100%;
    padding-top: 5px;
}

.settings-filters-popup-component-container .filter-options-list {
    width: 100%;
    padding: 10px 15px;
}

.settings-filters-popup-component-container .filter-option-item {
    width: max-content;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    /* border: 1px solid; */
}

.settings-filters-popup-component-container .filter-option-checkbox-container {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    border: 1px solid #d6d9d9;
    border-radius: 6px;
}

[dir="rtl"] .settings-filters-popup-component-container .filter-option-checkbox-container {
    margin-right: 0;
    margin-left: 10px;
}

.settings-filters-popup-component-container .filter-option-checkbox-wrapper, .settings-filters-popup-component-container .filter-option-checkbox-img-container {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.settings-filters-popup-component-container .filter-option-checkbox-img-container img {
    width: 100%;
    filter: brightness(0) saturate(100%) invert(71%) sepia(53%) saturate(686%) hue-rotate(30deg) brightness(90%) contrast(114%);
}

.settings-filters-popup-component-container .filter-option-title-container {
    flex: 1;
}

.settings-filters-popup-component-container .filter-option-title-container p {
    font-size: 21px;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
    line-height: 25px;
}

.settings-filters-popup-component-container .action-btns-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px 20px;
}

.settings-filters-popup-component-container .btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1px 30px;
    border-radius: 30px;
}

.settings-filters-popup-component-container .btn {
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 5px 0;
}

.settings-filters-popup-component-container .cancel-btn-container {
    background: #a0a1a3;
}

.settings-filters-popup-component-container .cancel-btn img {
    width: 70%;
}

.settings-filters-popup-component-container .ok-btn-container {
    background: #009df4;
}

.settings-filters-popup-component-container .ok-btn img {
    width: 90%;
}

@media (max-width: 375px) {
    .settings-filters-popup-component-container .settings-filters-popup-header-img-container {
        width: 55px;
    }

    .settings-filters-popup-component-container .filter-option-checkbox-container {
        width: 25px;
        height: 25px;
    }

    .settings-filters-popup-component-container .filter-option-title-container p {
        font-size: 19px;
    }

    .settings-filters-popup-component-container .action-btns-container {
        justify-content: space-around;
    }

    .settings-filters-popup-component-container .btn-container {
        /* padding: 1px 25px; */
        height: 35px;
    }

    .settings-filters-popup-component-container .btn {
        width: 32px;
    }
}

@media (max-width: 320px) {
    .settings-filters-popup-component-container .settings-filters-popup-component-wrapper {
        width: 90%;
    }

    .settings-filters-popup-component-container .settings-filters-popup-header-img-container {
        width: 50px;
    }

    .settings-filters-popup-component-container .filter-option-checkbox-container {
        width: 23px;
        height: 23px;
    }

    .settings-filters-popup-component-container .filter-option-title-container p {
        font-size: 18px;
    }
}

</style>